<template>
  <div class="cw-collapsable__wrapper" v-show="isVisible">
    <cw-toggle :label="cmpLabel" :value="currentValue" v-on:toggleChanged="valueChanged">
      <template v-slot:title="label">
        <h2>{{ label.title }}</h2>
      </template>
    </cw-toggle>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import expertviewMixin from './experviewMixin';
import CactusStrings from './CactusStringsMixin';
import cwToggle from './cwToggle.vue';

export default {
  name: 'CwCollapsableWrapper',
  mixins: [CactusStrings, expertviewMixin],
  components: { cwToggle },
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {};
  },
  created() {
    this.$log.debug('cwCollapsableWrapper::created()');
    this.selectedData = this.currentDataFromFwApp;

    if (this.ruleSubscriber.length > 0) {
      this.applyRules();
    }

    if (this.ruleProvider.length > 0) {
      const defaultValue = this.cmpConfig.value.default.default;
      this.applyRuleProvider(defaultValue);
    }

    this.valueChanged(this.selectedData);
  },
  computed: {
    ...mapGetters(['latestAppData']),

    currentValue() {
      return JSON.parse(this.currentDataFromFwApp);
    },

    cmpLabel() {
      const label = this.cmpConfig.component.decorator.label_component.toString();
      return this.getCactusString(label);
    }
  },
  methods: {
    ...mapActions(['setRuleProvider']),

    valueChanged(newVal) {
      let fwApp = this.getFwApp();
      this.applyRuleProvider(newVal);

      this.$log.debug('cwCollapsableWrapper::valueChanged', {
        app: undefined,
        parameter: fwApp.param,
        value: newVal
      });

      this.setExpertViewParams({
        app: undefined,
        parameter: fwApp.param,
        value: newVal
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cw-collapsable__wrapper {
  font-family: 'SiemensSansGlobalCC-Bold', 'Helvetica Neue', Helvetica, sans-serif;
  font-weight: bold;
  color: #41aaaa;
  font-size: 100%;

  /deep/ .tgl {
    & + .tgl-btn {
      background: none;
      border-radius: 0;

      &::after {
        background: url(../../assets/img/ico-expand-list.svg) center center no-repeat;
        transform: rotate(0deg);
        content: '';
        height: 20px;
        width: 20px;
        top: -5px;
      }
    }

    &:checked + .tgl-btn:after {
      left: 0;
      transform: rotate(180deg);
    }
  }

  /deep/ .tgl-light + .tgl-btn {
    &::after {
      border-radius: 0;
    }
  }

  /deep/ .content {
    margin-right: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .text h2 {
      font-size: 14px;
    }
  }
}
</style>
